<template>
  <div class="product-bind">
    <div v-for="(item, index) in incentiveList" :key="index" class="event-card" @click="toUrl(`/incentive/incentiveDetail?scanId=${item.id}`)">
      <div>
        <div class="card-header">
          <span class="status-tag txt-ellipsis" :style="{ 'color': item.jobColor, 'border': `1px solid ${item.jobColor}` }">{{ item.job }}</span>
          <span class="event-title txt-ellipsis">{{ item.nickname }} {{ item.orderType === 0 ? $t('shared.bindProduct') : item.orderType === 2 ? $t('shared.uploadSalesReceipt') : item.orderType === 3 ? $t('shared.inviteFansToJoinTheCommunity') : '' }} <span v-if="item.orderType !== 3">{{ item.totalQuantity }} {{ $t('form.pcs') }}</span></span>
        </div>

        <div class="time-content">
          <img src="@/assets/images/map_time.png" class="row-icon" />
          <div class="">{{ item.localCreateTime }}</div>
        </div>

        <div class="store-info">
          <img src="@/assets/images/store.png" class="row-icon" />
          <span class="store-name van-ellipsis">{{ item.customerName }}</span>
        </div>
      </div>
      <div class="incentive-num txt-ellipsis">+{{ item.totalIntegral }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    incentiveList: {
      type: Array,
      default: () => {}
    }
  },
  methods: {
    toUrl (url) {
      this.$router.push(url)
    }
  }
}
</script>

<style lang="less" scoped>
.product-bind {
  .event-card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    padding: 10px;
    border-bottom: 1px solid rgb(238, 229, 229);
    &:first-child {
      border-top: 1px solid rgb(238, 229, 229);
    }
    .card-header {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      .event-title {
        max-width: 212px;
        font-size: 13px;
        color: #333;
        margin-right: 8px;
      }

      .status-tag {
        max-width: 70px;
        font-size: 10px;
        padding: 2px 6px;
        border-radius: 2px;
        color: #307bff;
        border: 1px solid #307bff;
        margin-right: 5px;
      }
    }

    .time-content {
      display: flex;
      align-items: center;
      font-size: 12px;
      margin-bottom: 8px;
      color: #555555;
    }

    .store-info {
      display: flex;
      align-items: center;
      .store-name {
        flex: 1;
        font-size: 12px;
        color: #555555;
      }
    }

    .row-icon {
      width: 13px;
      height: 13px;
      margin-right: 6px;
      object-fit: contain;
    }
    .incentive-num {
      max-width: 74px;
      font-size: 15px;
      color: #307bff;
      font-weight: bold;
      text-align: right;
    }
  }
}
</style>
